import { render, staticRenderFns } from "./CenterContent.vue?vue&type=template&id=2daa287a&scoped=true"
import script from "./CenterContent.vue?vue&type=script&lang=js"
export * from "./CenterContent.vue?vue&type=script&lang=js"
import style0 from "./CenterContent.vue?vue&type=style&index=0&id=2daa287a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2daa287a",
  null
  
)

export default component.exports